import * as React from "react";
import "./picture.css";

import Picture1 from "../../assets/Picture1.jpg";
import Picture2 from "../../assets/Picture2.jpg";
import Picture3 from "../../assets/Picture3.jpg";
import Picture4 from "../../assets/Picture4.jpg";

import {
  ImageList,
  ImageListItem,
  Dialog,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";

export default function PictureList() {
  <Helmet>
    <title>Pictures – Ponvel Exim | Product & Brand Gallery</title>
    <meta
      name="description"
      content="Explore Ponvel Exim’s picture gallery featuring our brands and products across food, FMCG, coir, and textiles. High-quality images for buyers and partners."
    />
    <meta
      name="keywords"
      content="Ponvel Exim gallery, Ponvel Exim pictures, product photos, brand images, FMCG pictures, food product photos, coir product images, textile images"
    />
    <link rel="canonical" href="https://ponvelexim.com/picture" />

    {/* Open Graph */}
    <meta property="og:site_name" content="Ponvel Exim" />
    <meta property="og:locale" content="en_IN" />
    <meta
      property="og:title"
      content="Pictures – Ponvel Exim | Product & Brand Gallery"
    />
    <meta
      property="og:description"
      content="Browse Ponvel Exim’s product and brand gallery across food, FMCG, coir, and textiles."
    />
    <meta property="og:image" content="https://ponvelexim.com/logo192.png" />
    <meta property="og:url" content="https://ponvelexim.com/picture" />
    <meta property="og:type" content="website" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta
      name="twitter:title"
      content="Pictures – Ponvel Exim | Product & Brand Gallery"
    />
    <meta
      name="twitter:description"
      content="See our products and brands in the Ponvel Exim gallery."
    />
    <meta name="twitter:image" content="https://ponvelexim.com/logo192.png" />
  </Helmet>;

  const itemData = [
    { img: Picture1, title: "Picture 1" },
    { img: Picture2, title: "Picture 2" },
    { img: Picture3, title: "Picture 3" },
    { img: Picture4, title: "Picture 4" },
  ];

  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  let cols = 4;
  if (isXs) cols = 1;
  else if (isSm) cols = 2;
  else if (isMdUp) cols = 4;

  const [open, setOpen] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(null);

  const handleOpen = (idx) => {
    setActiveIndex(idx);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const goNext = () => setActiveIndex((i) => (i + 1) % itemData.length);
  const goPrev = () =>
    setActiveIndex((i) => (i - 1 + itemData.length) % itemData.length);

  React.useEffect(() => {
    function onKey(e) {
      if (!open) return;
      if (e.key === "ArrowRight") goNext();
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "Escape") handleClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <ImageList cols={cols} gap={10} className="picture-section">
        {itemData.map((item, idx) => (
          <ImageListItem key={item.img}>
            <button
              onClick={() => handleOpen(idx)}
              className="picture-trigger"
              aria-label={`Open ${item.title}`}>
              <img
                src={item.img}
                alt={item.title}
                loading="lazy"
                className="picture-thumb"
              />
            </button>
          </ImageListItem>
        ))}
      </ImageList>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        PaperProps={{ className: "lightbox-paper" }}>
        {activeIndex !== null && (
          <Box className="lightbox-root">
            <IconButton
              aria-label="Close"
              onClick={handleClose}
              className="icon-btn lightbox-close">
              <CloseIcon />
            </IconButton>
            <IconButton
              aria-label="Previous"
              onClick={goPrev}
              className="icon-btn lightbox-prev">
              <ArrowBackIosNewIcon />
            </IconButton>
            <IconButton
              aria-label="Next"
              onClick={goNext}
              className="icon-btn lightbox-next">
              <ArrowForwardIosIcon />
            </IconButton>
            <Box className="lightbox-stage">
              <img
                src={itemData[activeIndex].img}
                alt={itemData[activeIndex].title}
                className="lightbox-image"
              />
            </Box>
            <Box className="lightbox-caption">
              <div className="lightbox-title">
                {itemData[activeIndex].title}
              </div>
            </Box>
          </Box>
        )}
      </Dialog>
    </>
  );
}
